import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyResponse'
})
export class EmptyResponsePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      return value;
    } else {
      return "--- ---";
    }
  }

}
